import React, { useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import TuneIcon from '@mui/icons-material/Tune';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { COLOR_GREY_200, COLOR_GREY_600 } from 'src/utils/colors';

const ToggleVisibilityButton = ({
  actionOnClick,
  isDisabled,
  isLocked,
  Icon,
  title,
  isDefaultExpanded,
  customWidth,
}: {
  actionOnClick: () => void;
  isDisabled?: boolean;
  isLocked: boolean;
  Icon?: any;
  title?: any;
  isDefaultExpanded?: boolean;
  customWidth?: string;
}) => {
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down(900));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between(900, 1200));
  const [showHelperText, setShowHelperText] = useState(false);
  const expandedWidth = customWidth ? customWidth : '200px';

  useEffect(() => {
    if (isDefaultExpanded) {
      setShowHelperText(true);
    }
  }, [isDefaultExpanded]);

  const buttonIconStyle = { px: '0 !important', margin: '0 !important' };

  const buttonContent = (
    <>
      {isLocked ? (
        <LockOutlinedIcon sx={buttonIconStyle} />
      ) : Icon ? (
        <Icon sx={buttonIconStyle} />
      ) : (
        <TuneIcon sx={buttonIconStyle} />
      )}
      {showHelperText && !isMediumScreen && (
        <Typography
          variant="button"
          sx={{ opacity: showHelperText ? 1 : 0, overflow: 'hidden', ml: 1 }}
        >
          {title ? title : 'Configure'}
        </Typography>
      )}
    </>
  );

  return (
    <Tooltip title={title ? title : 'Configure'} disableHoverListener={!isMediumScreen}>
      <Button
        size="small"
        onClick={() => !isDisabled && actionOnClick()}
        disabled={isDisabled}
        onMouseEnter={() =>
          !isMobileDevice && !isMediumScreen && !isDefaultExpanded && setShowHelperText(true)
        }
        onMouseLeave={() =>
          !isMobileDevice && !isMediumScreen && !isDefaultExpanded && setShowHelperText(false)
        }
        sx={{
          background: COLOR_GREY_200,
          color: COLOR_GREY_600,
          fontSize: '16px',
          minWidth: '50px',
          width: isDefaultExpanded
            ? expandedWidth
            : showHelperText && !isMediumScreen
            ? expandedWidth
            : '50px',
          maxWidth: '100%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          transition: 'width 0.25s ease, background 0.25s ease, color 0.25s ease',
          '&:hover': {
            width: isDefaultExpanded
              ? expandedWidth
              : isMobileDevice || isMediumScreen
              ? '50px'
              : expandedWidth,
            background: isMobileDevice || isMediumScreen ? COLOR_GREY_200 : '#222',
            color: isMobileDevice || isMediumScreen ? COLOR_GREY_600 : '#fff',
          },
        }}
      >
        {buttonContent}
      </Button>
    </Tooltip>
  );
};

export default ToggleVisibilityButton;
